import React, { createContext, useContext } from 'react';

const AuthContext = createContext();

export function AuthProvider({ children, onLogout }) {
  return (
    <AuthContext.Provider value={{ onLogout }}>
      {children}
    </AuthContext.Provider>
  );
}

export function useAuth() {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error('useAuth debe usarse dentro de AuthProvider');
  }
  return context;
}
